import React from "react"
import SideBarMenuListItem from "../layout/sidebarmenulistitem"
import useGettingStartedDataWeb from '../../utils/hooks/webData/useGettingStartedDataWeb'

const GettingStarted = ({ expandAll, icon, toggleExpandAll }) => {
  const gettingStarted = useGettingStartedDataWeb()

  return (
    gettingStarted && (
      <SideBarMenuListItem data={gettingStarted} expandAll={expandAll} icon={icon}  toggleExpandAll={toggleExpandAll}/>
    )
  )
}

export default GettingStarted
